module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACQSURBVHgBjZKLDYMwDERxJ+gIHqEjdJN2gzJKmQDYACaAEdgANmAEcwcR4ieck54Sx3eKYkUSyMyeWH7gBQZQAp59gIIaVCIy0KygN1/0KAO5Y2Q/Dfs/A6P5eoOGXmGV+GrDW5SBPhQx6h5hIrHK5pFa5JTWmPmjZU93d92EzuZDqNiYG1t+wb1g+oL0qjcBNF8oSoCrRSoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/heart.png
// module id = YfaA
// module chunks = 1